import { UserPermissions } from '@centecomm/portal-service';
import { FeatureConfiguration } from 'Core/Types/FeatureConfiguration';
import Icon from 'Icons/NavigationItem/Locations';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements';
import { LaunchDarklyFlags } from 'utils/Hooks/LaunchDarkly/launchDarklyFlags';

const LazyHvacComplianceSettingsPage = React.lazy(() => import('./Pages'));

const hvacComplianceSettingsConfiguration: FeatureConfiguration = {
    name: 'administrationFeature:system.hvacCompliance.title',
    navigationItem: {
        route: {
            text: 'administrationFeature:sidebar.system.hvacCompliance.title',
            url: '/hvac-compliance-settings',
            Icon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyHvacComplianceSettingsPage />
                </React.Suspense>
            ),
            tenantRoot: null,
        },
        isGloballyAccessible: false,
        permissions: [UserPermissions.ManageAdminConfig],
    },
    disableFeature: [],
    // Standalone item only appears when neither grouping surface is on: the Compliance Hub
    // groups the system compliances, and the Compliance Builder implies the Hub
    visibilityRule: {
        [LaunchDarklyFlags.ComplianceHub]: { $ne: true },
        [LaunchDarklyFlags.ComplianceBuilder]: { $ne: true },
    },
};

export default hvacComplianceSettingsConfiguration;
